<template>
	<div
		ref="lineupContainer"
		class="lineup-container"
	>
		<EventBannerAd />
		<InfiniteScroll>
			<div
				v-for="(players, position) in playerPositionMap"
				:key="position"
			>
				<template v-if="position">
					<div
						class="player-position"
					>
						{{ position }}
					</div>
					<div
						class="divider"
					/>
				</template>
				<div
					class="list-container"
				>
					<LineupItem
						v-for="(player, index) in players"
						:key="player.id"
						:player="player"
						:is-last="players.length - 1 === index"
						@click.native="$emit('item-click', player)"
					/>
				</div>
			</div>
		</InfiniteScroll>
	</div>
</template>

<script>
import LineupItem from './LineupItem';
import { mapGetters } from 'vuex';
import { SportName } from '@shared/enums/SportName';
import EventBannerAd from '@components/EventBannerAd';
import { HandballPlayerPositionHandler, IceHockeyPlayerPositionHandler, HornussenPlayerPositionHandler } from './player-position-handlers';
import { UNKNOWN } from './player-position-handlers/utils';
import InfiniteScroll from '@components/infinite-scroll/InfiniteScroll.vue';

export default {
	name:       'LineupTable',
	components: { InfiniteScroll, LineupItem, EventBannerAd },
	props:      {
	  	players: {
	    	type:     Array,
			required: true,
		},
		tableHeader: {
	    	type:     Object,
			required: true,
		},
	},
	data() {
	    return {
			playerPositionMap: {},
		};
	},
	computed: {
		...mapGetters({
			sportName: 'event/sportName',
		}),
	},
	mounted() {
		try {
			this.initPlayerPositions();
		} catch (error) {
			console.error('Initialization error:', error);
		}
	},
	methods: {
		initPlayerPositions() {
			let handler;

			if (this.sportName === SportName.HANDBALL) handler = new HandballPlayerPositionHandler(this.players);
			else if (this.sportName === SportName.ICE_HOCKEY) handler = new IceHockeyPlayerPositionHandler(this.players);
			else if (this.sportName === SportName.HORNUSSEN) handler = new HornussenPlayerPositionHandler(this.players);
			else throw new Error(`Sport ${this.sportName} has no lineup handler defined`);

			let lineup = handler.getLineup();

			if (lineup[UNKNOWN]) {
				if (lineup[UNKNOWN].length === this.players?.length) lineup = { '': lineup[UNKNOWN] };
				else {
					const { unknown: _unknown, ...knownPositions } = lineup;
					knownPositions[this.$I18n.trans('commons.unknown')] = lineup[UNKNOWN];
					lineup = knownPositions;
				}
			}

			this.playerPositionMap = lineup;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.player-position {
	@include text-md-1;
	font-weight: 500;
	margin: 12px auto 8px 0;
	padding-left: 8px;
}

.divider {
	height: 1px;
	background: var(--color-grey-900);
	margin-left: 8px;
	margin-right: 8px;
}

.lineup-container {
  overflow-x: hidden;
  overflow-y: auto;
}

.lineup-header {
  @include text-sm-2(true);
  background: var(--color-black);
  padding: 14px 0 14px 90px;
  display: flex;
  justify-content: space-evenly;
}

.lineup-header p {
  width: 25%;
  margin: 0;
  font-size: 14px;
  margin-left: 18px;
}
</style>
